//@ts-nocheck
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { uploadInterViewVideoData ,createApplication, fetchApplicationDataList, fetchApplicationDetails, uploadResume,fetchAiInterviewDetails,startInterview,endInterView,completeInterView } from '../../../services/applicationService';
import { CandidateResponse, CandidateState } from './applicationTypes';
import { ApiError } from '../jobAuth/JobAuthTypes';

// Upload Resume Thunk
export const uploadCandidateResume = createAsyncThunk<
  CandidateResponse,
  { file: File; jobId: string; base_slug: string; app_id: string; email: string },  // ✅ Added `app_id`
  { rejectValue: string }
>(
  'candidate/uploadResume',
  async ({ file, jobId, base_slug, app_id, email }, { rejectWithValue }) => { // ✅ Passing `app_id`
    try {
      const response = await uploadResume(file, jobId, base_slug, app_id, email); // ✅ Pass `app_id`
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Resume upload failed');
    }
  }
);

// Create Application Thunk
export const createCandidateApplication = createAsyncThunk<
  CandidateResponse,
  {
    job_id: string;
    base_slug: string;
    app_id: string;
    app_email: string;
    name?: string;
    phone?: string;
    location?: string;
    summary?: string;
    education?: any;
    experience?: any;
    links?: string[];
    resume?: string;
    cover_letter?: string;
  },
  { rejectValue: string }
>(
  'candidate/createApplication',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createApplication(payload);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Application creation failed');
    }
  }
);

// aaplicationList
export const fetchApplicationList = createAsyncThunk<
  Application[],
  string,
  { rejectValue: string }
>('jobs/fetchJobs', async (baseSlug, { rejectWithValue }) => {
  try {
    const response = await fetchApplicationDataList();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to fetch jobs');
  }
});


export const fetchApplicationDataDetails = createAsyncThunk<
  Job,
  { appId: string },
  { rejectValue: string }
>('jobs/fetchApplicationDataDetails', async ({ appId }, { rejectWithValue }) => {
  try {
    const response = await fetchApplicationDetails(appId);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to fetch job details');
  }
});
export const fetchAiInterviewDataDetails = createAsyncThunk<
  Job,
  { appId: any },
  { rejectValue: string }
>('jobs/fetchAiInterviewDataDetails', async ({ appId }, { rejectWithValue }) => {
  try {
    const response = await fetchAiInterviewDetails(appId);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to fetch job details');
  }
});


export const startAiInterview = createAsyncThunk<
  Job,
  { appId: any,questinNo:any },
  { rejectValue: string }
>('jobs/startAiInterview', async ({ appId,questinNo }, { rejectWithValue }) => {
  try {
    const response = await startInterview(appId,questinNo);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to fetch job details');
  }
});

export const endAiInterview = createAsyncThunk<
  CandidateResponse,
  { appId: any,questionNo:any,video:any  },  // ✅ Added `app_id`
  { rejectValue: string }
>(
  'candidate/endAiInterview',
  async ({ appId,questionNo,video }, { rejectWithValue }) => { // ✅ Passing `app_id`
    try {
      const response = await endInterView(appId,questionNo,video); // ✅ Pass `app_id`
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Resume upload failed');
    }
  }
);

export const completeAiInterview = createAsyncThunk<
  CandidateResponse,
  { appId: any },
  { rejectValue: string }
>(
  'candidate/completeAiInterview',
  async ({ appId }, { rejectWithValue }) => {
    try {
      const response = await completeInterView(appId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Resume upload failed');
    }
  }
);

export const uploadInterviewVideo = createAsyncThunk<BaseResponse, { payload: any; folderName: any }, { rejectValue: string }>(
  'ai/uploadInterviewVideo',
  async ({ payload, folderName }, { rejectWithValue }) => {
    try {
      if (!payload.file) {
        return rejectWithValue('file is required');
      }
      console.log("slice upload ===> ",payload, folderName);
      const response = await uploadInterViewVideoData(payload, folderName);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to upload base cover');
    }
  }
);

const initialState: CandidateState = {
  uploadResumeStatus: 'idle',
  uploadResumeError: null,
  uploadResumeData: null,
  createApplicationStatus: 'idle',
  createApplicationError: null,
  createApplicationData: null,
  applicationListStatus: 'idle',
  applicationListError: null,
  applicationList: [],
  fetchApplicationDataDetailsStatus : 'idle',
  fetchApplicationDataDetailsError: null,
  fetchApplicationDataDetails: null,
  fetchAiInterviewDataDetails: null
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Resume Upload
      .addCase(uploadCandidateResume.pending, (state) => {
        state.uploadResumeStatus = 'loading';
        state.uploadResumeError = null;
      })
      .addCase(uploadCandidateResume.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.uploadResumeStatus = 'succeeded';
        state.uploadResumeData = action.payload;
        state.uploadResumeError = null;
      })
      .addCase(uploadCandidateResume.rejected, (state, action) => {
        state.uploadResumeStatus = 'failed';
        state.uploadResumeError = action.payload || 'Resume upload failed';
      })
       .addCase(uploadInterviewVideo.pending, (state) => {
        state.uploadResumeStatus = 'loading';
        state.uploadResumeError = null;
      })
      .addCase(uploadInterviewVideo.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.uploadResumeStatus = 'succeeded';
        state.uploadResumeData = action.payload;
        state.uploadResumeError = null;
      })
      .addCase(uploadInterviewVideo.rejected, (state, action) => {
        state.uploadResumeStatus = 'failed';
        state.uploadResumeError = action.payload || 'Resume upload failed';
      })
      // Application Creation
      .addCase(createCandidateApplication.pending, (state) => {
        state.createApplicationStatus = 'loading';
        state.createApplicationError = null;
      })
      .addCase(createCandidateApplication.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.createApplicationStatus = 'succeeded';
        state.createApplicationData = action.payload;
        state.createApplicationError = null;
      })
      .addCase(createCandidateApplication.rejected, (state, action) => {
        state.createApplicationStatus = 'failed';
        state.createApplicationError = action.payload || 'Application creation failed';
      })
      // Fetch Application List
      .addCase(fetchApplicationList.pending, (state) => {
        state.applicationListStatus = 'loading';
        state.applicationListError = null;
      })
      .addCase(fetchApplicationList.fulfilled, (state, action: PayloadAction<Application[]>) => {
        state.applicationListStatus = 'succeeded';
        state.applicationList = action.payload;
        state.applicationListError = null;
      })
      .addCase(fetchApplicationList.rejected, (state, action) => {
        state.applicationListStatus = 'failed';
        state.applicationListError = action.payload || 'Failed to fetch application list';
      })
      // Fetch Application Details
      .addCase(fetchApplicationDataDetails.pending, (state) => {
        state.fetchApplicationListStatus = 'loading';
        state.fetchApplicationListError = null;
      })
      .addCase(fetchApplicationDataDetails.fulfilled, (state, action: PayloadAction<Job>) => {
        state.fetchApplicationListStatus = 'succeeded';
        state.fetchApplicationList = action.payload;
        state.fetchApplicationListError = null;
      })
      .addCase(fetchApplicationDataDetails.rejected, (state, action) => {
        state.fetchApplicationListStatus = 'failed';
        state.fetchApplicationListError = action.payload || 'Failed to fetch application details';
      })
       // Fetch Ai Interview details
       .addCase(fetchAiInterviewDataDetails.pending, (state) => {
        state.fetchApplicationListStatus = 'loading';
        state.fetchApplicationListError = null;
      })
      .addCase(fetchAiInterviewDataDetails.fulfilled, (state, action: PayloadAction<Job>) => {
        state.fetchApplicationListStatus = 'succeeded';
        state.fetchApplicationList = action.payload;
        state.fetchApplicationListError = null;
      })
      .addCase(fetchAiInterviewDataDetails.rejected, (state, action) => {
        state.fetchApplicationListStatus = 'failed';
        state.fetchApplicationListError = action.payload || 'Failed to fetch application details';
      });
  },
});

export default applicationSlice.reducer;
